/*
 * @Author: zhangcx33595
 * @Date: 2021-06-19 14:18:53
 * @LastEditors: zhangcx33595
 * @LastEditTime: 2021-07-29 15:20:27
 * @FilePath: \openplat-web\src\gtn\api\market.js
 */
import fetch from "./httpFetch.js";
import Cookies from "js-cookie";
const modelName = "/openplat-service-server/v/service";
const modelNameWord = "/openplat-service-server/v/word";
/***获取请求条件***/
export function getSearchConditionsInit(data) {
  return fetch.post(modelName + "/getSearchConditionsInit", data);
}
/***获取市场详情-对外***/
export function queryMarketDetailList(params) {
  return fetch.post(modelName + "/queryMarketDetailOutList", params);
}


/***获取市场详情-对外***/
export function queryMarketDetailListForStore(params) {
  return fetch.post(modelName + "/queryMarketDetailListForStore", params);
}
/***获取热门搜索词***/
// export function queryHotSearchWord() {
//   return fetch.post(modelNameWord + "/queryHotSearchWord", {
//     company_id: 0
//   });
// }




// WEBPACK FOOTER //
// ./src/gtn/api/market.js